import { useEffect } from 'react';
import useAppEvent from 'hooks/useAppEvent';
import { AppEventType, OpenUpdateLeadModalEventPayload } from 'models/Events';
import useOpenLeadModal from '../modal/useOpenLeadModal';

const useOpenUpdateLeadModalEventHandler = () => {
  const { subscribe, unsubscribe } = useAppEvent();
  const { updateLeadModal } = useOpenLeadModal();

  useEffect(() => {
    const openModalListener = ({
      detail: { params },
    }: CustomEvent<OpenUpdateLeadModalEventPayload>) => {
      updateLeadModal(params);
    };

    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    subscribe(AppEventType.OPEN_UPDATE_LEAD_MODAL, openModalListener);

    return () => {
      // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      unsubscribe(AppEventType.OPEN_UPDATE_LEAD_MODAL, openModalListener);
    };
  }, []);
};

export default useOpenUpdateLeadModalEventHandler;
